import React from "react";
import { useSelector } from "react-redux";
import { Calculator } from "./index";
import { CalculatorType } from "../hooks";

const selectShown = (state) => state.uiReducer.sideBarCalculatorShown;

export const SideBarCalculator = ({ calculatorType }) => {
  if (calculatorType === CalculatorType.REGAUTH) {
    return <Calculator calculatorType={calculatorType} />;
  }

  const shown = useSelector(selectShown);
  if (!shown) return null;

  return <Calculator calculatorType={calculatorType} />;
};
